module.exports = __webpack_public_path__ + "4ffec86137ecf978472104c2a40dea5b.svg";